import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'
import ListItem from '../../ListItem'
import Text from '../../Text'

import styles from './styles.scss'

const Item = (props) => {
  const { 
    disableHover, 
    href, 
    icon,
    label, 
    value, 
  } = props

  return (
    <Box className={styles.root}>
      <ListItem
        boxProps={{
          alignItems: 'center',
          as: 'a',
          padding: 'large',
        }}
        disableHover={disableHover}
        href={href}
        showAngleIcon={!!href}
      >
        {icon && (
          <Box marginRight="large" width="auto">
            {icon}
          </Box>
        )}

        <Box flexDirection="column">
          <Text color="bodyFontLightColor" fontSize="xsmall" marginBottom="small">
            {label}
          </Text>

          <Text fontSize="medium">
            {value}
          </Text>
        </Box>
      </ListItem>
    </Box>
  )
}

Item.propTypes = {
  disableHover: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.object,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

export default Item
